import React, { useEffect } from "react";

 function ServicesSection() {
  useEffect(() => {
    const revealElements = document.querySelectorAll(".reveal");
    const revealOnScroll = () => {
      revealElements.forEach((el) => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight - 80) {
          el.classList.add("active");
        }
      });
    };

    window.addEventListener("scroll", revealOnScroll);
    revealOnScroll();
    return () => window.removeEventListener("scroll", revealOnScroll);
  }, []);
  const products = [
    {
      title: "Polytunnel",
      desc: "All-weather protected structure designed for controlled crop cultivation.",
      img: "https://kryzen.com/wp-content/uploads/2024/10/22.jpg",
      link: "https://kryzen.com/kryzen-polytunnel/",
    },
    {
      title: "Nethouse / Shadehouse",
      desc: "Light-filtering structures that protect crops from pests & harsh climate.",
      img: "https://kryzen.com/wp-content/uploads/2024/10/31.jpg",
      link: "https://kryzen.com/kryzen-nethouse-shadehouse/",
    },
    {
      title: "Naturally Ventilated Polyhouse",
      desc: "Eco-friendly polyhouse with efficient natural ventilation.",
      img: "https://kryzen.com/wp-content/uploads/2024/10/32.jpg",
      link: "https://kryzen.com/kryzen-naturally-ventilated-polyhouse/",
    },
    {
      title: "Fan & Pad Polyhouse",
      desc: "Fully climate-controlled farming system with advanced cooling.",
      img: "https://kryzen.com/wp-content/uploads/2024/10/38.jpg",
      link: "https://kryzen.com/kryzen-exhaust-fan-pad-controlled-environment-polyhouse/",
    },
    {
      title: "Polycarbonate House",
      desc: "Durable insulated structure supporting high-performance farming.",
      img: "https://kryzen.com/wp-content/uploads/2024/10/kryzen-hp-1.jpg",
      link: "https://kryzen.com/kryzen-poly-carbonate/",
    },
    {
      title: "Vertical Hydroponic NFT",
      desc: "Space-optimized vertical NFT farming for high-yield leafy greens.",
      img: "https://kryzen.com/wp-content/uploads/2024/10/42.jpg",
      link: "https://kryzen.com/kryzen-vertical-hydroponic-farming/",
    },
    {
      title: "Flat Hydroponic NFT",
      desc: "Commercial grade NFT system for leafy greens & herbs.",
      img: "https://kryzen.com/wp-content/uploads/2024/10/kryzen-page.jpg",
      link: "https://kryzen.com/kryzen-flat-nft-hydroponics/",
    },
    {
      title: "Soil-less Growbags",
      desc: "Premium, high-quality growbags for soilless hydroponic cultivation.",
      img: "https://kryzen.com/wp-content/uploads/2024/10/48.jpg",
      link: "https://kryzen.com/kryzen-soil-less-growbags/",
    },
    {
      title: "Dutch Buckets",
      desc: "Ideal system for vine crops like tomatoes, capsicum & cucumbers.",
      img: "https://kryzen.com/wp-content/uploads/2024/10/51.jpg",
      link: "https://kryzen.com/kryzen-grow-buckets-dutch-buckets/",
    },
    {
      title: "Hydroponic Masterclass",
      desc: "Deep-dive masterclass for aspiring commercial hydroponic growers.",
      img: "https://d502jbuhuh9wk.cloudfront.net/orgData/65dc4780e4b0b60e6be0bdc1/pages/assets/images/d8l6165dc485be4b02b7a63f5d073scaledcover.jpg",
      link: "https://www.hydroponicmasterclass.com/",
    },
    {
      title: "Hydroponic Webinar",
      desc: "Beginner-friendly webinar to understand hydroponic farming basics.",
      img: "https://alpha.kryzen.com/static/media/fridayWebinar.0880fd6c6d28343857fb.png",
      link: "https://alpha.kryzen.com/hydroponic-webinar?theme=light",
    },
  ];

  return (
    <div className="bg-light">
      {/* Animation CSS */}
      <style>{`
        .reveal {
          opacity: 0;
          transform: translateY(25px);
          transition: all 0.7s cubic-bezier(0.23, 1, 0.32, 1);
        }
        .reveal.active {
          opacity: 1;
          transform: translateY(0);
        }
        .delay-1 { transition-delay: 0.1s; }
        .delay-2 { transition-delay: 0.2s; }
        .delay-3 { transition-delay: 0.3s; }
        .delay-4 { transition-delay: 0.4s; }
        .delay-5 { transition-delay: 0.5s; }
        .delay-6 { transition-delay: 0.6s; }
        .delay-7 { transition-delay: 0.7s; }
        .delay-8 { transition-delay: 0.8s; }
        .delay-9 { transition-delay: 0.9s; }
      `}</style>

      <div className="container-xl">
        <h1 className="mt-0 mb-4 fs-3 fs-md-2 fs-lg-1  border border-0 border-secondary  text-white p-2 rounded-3 text-center reveal" style={{background:"limegreen"}} >
          Our Products & Solutions
        </h1>


        <div className="row row-cards row-deck">
  {products.map((p, i) => (
    <div
      className="col-sm-6 col-md-6 col-lg-6 mb-4 animate-slide-up"
      key={i}
    >
      <div
        className="card rounded-3 overflow-hidden bg-white border card-hover-shadow card-transition
        d-flex flex-row h-100"
      >
        {/* LEFT IMAGE */}
        <img
          src={p.img}
          alt={p.title}
          className="object-fit-cover"
          style={{ width: "40%", height: "100%", objectFit: "cover" }}
        />

        {/* RIGHT TEXT CONTENT */}
        <div className="card-body d-flex flex-column flex-grow-1">
          <div className="product-title">{p.title}</div>
          <p className="text-muted" style={{ fontSize: "0.85rem" }}>
            {p.desc}
          </p>

          {/* Push button to bottom */}
          <div className="mt-auto">
            <button
              onClick={() => (window.location.href = p.link)}
              className="btn btn-outline-success w-100"
            >
              Know More
            </button>
          </div>
        </div>
      </div>
    </div>
  ))}
</div>

        {/* Title */}
        <h2 className="text-center fw-bold display-5 mb-2 reveal">
          Our Services
        </h2>

        {/* Subtitle */}
        <p
          className="text-secondary text-center fs-4 mx-auto mb-4 reveal delay-1"
          style={{ maxWidth: 750 }}
        >
          Kryzen delivers a complete suite of modern agricultural solutions —
          from rural upliftment programs to advanced urban farming systems,
          research-driven projects, and CSR-aligned initiatives that transform
          agriculture across India.
        </p>

        {/* Services Grid */}
        <div className="row row-deck g-4 mt-4">
  {services.map((service, index) => (
    <div className="col-sm-6 col-lg-6" key={index}>
      <div className={`card shadow-sm reveal delay-${index + 1}`}>
        
        {/* Horizontal card: vertical on mobile, row on md+ */}
        <div className="card-body d-flex flex-column flex-md-row align-items-start gap-3">
          
          {/* LEFT ICON */}
          <div className="fs-2 text-success flex-shrink-0">
            {service.icon}
          </div>

          {/* RIGHT TEXT + BUTTON */}
          <div className="d-flex flex-column w-100">
            <h3 className="fw-bold mb-1">{service.title}</h3>
            <p className="text-secondary">{service.text}</p>

            <button
              onClick={() => (window.location.href = service.link)}
              className="btn btn-outline-success mt-auto align-self-start"
            >
              Know More →
            </button>
          </div>
        </div>

      </div>
    </div>
  ))}
</div>

      </div>
    </div>
  );
}

export default ServicesSection
// Updated services list
const services = [
  {
    icon: "🚜",
    title: "Rural Farming Tech",
    text: "Enabling rural farmers with modern tools, protected cultivation, and farm automation for scalable income growth.",
    link: "https://kryzen.com/kryzen-for-rural-farmer/",
  },
  {
    icon: "🏙️",
    title: "Urban Farming Tech",
    text: "Balcony, terrace, and commercial indoor farming solutions for cities aiming at hyper-local food production.",
    link: "https://kryzen.com/kryzen-for-urban-farmer/",
  },
  {
    icon: "🔬",
    title: "Crop Research Lab",
    text: "Custom R&D setups for universities, startups, and agri-enterprises to test new crops, nutrients, and systems.",
    link: "https://kryzen.com/kryzen-for-crop-research/",
  },
  {
    icon: "🌱",
    title: "Soil-less Growing",
    text: "Comprehensive hydroponic, NFT, coco-peat, and inert medium-based cultivation systems for high-yield farming.",
    link: "https://kryzen.com/kryzen-for-soil-less-growing/",
  },
  {
    icon: "🏢",
    title: "Mega Farming Projects",
    text: "Execution of 1–50 acre high-tech farms with climate control, automation, commercial planning, and long-term support.",
    link: "https://kryzen.com/kryzen-for-mega-farming//",
  },
  {
    icon: "🤝",
    title: "Agro-CSR Planning",
    text: "CSR-aligned agriculture projects for corporates supporting farmer empowerment, education, and sustainability.",
    link: "https://kryzen.com/kryzen-for-agro-csr-plan/",
  },
  {
    icon: "🌐",
    title: "Kryzen Community",
    text: "A growing national network of hydroponic growers, educators, investors, and innovators.",
    link: "https://kryzen.com/kryzen-for-building-community/",
  },
  {
    icon: "📍",
    title: "Site Inspection Kit",
    text: "On-site feasibility analysis: climate mapping, land survey, water testing, and project recommendations.",
    link: "https://kryzen.com/site-inspection-kit/",
  },
  {
    icon: "💰",
    title: "Grants & Subsidies",
    text: "Assistance with government grants, agri subsidy schemes, and documentation for new farming entrepreneurs.",
    link: "https://kryzen.com/kryzen-for-grants-subsidies/",
  },
];
